const backendUrl = process.env.REACT_APP_BACKEND_URL ?? '';

export function getOcrBackendUrl(pageOrigin: string, configuredBackendUrl: string): string {
  // Production aliases share a backend, but must not overwrite each other's
  // host-only identity cookie. Keep configured endpoints for local development.
  return ['https://chat.lapathoniia.top', 'https://app.lapathoniia.top'].includes(pageOrigin)
    ? pageOrigin : configuredBackendUrl;
}

export const MODEL_IDS = {
  mamay: 'MamayLM-Gemma-3-27B-IT-v2.0',
  rukopys: 'rukopys-ocr',
  lapa: 'LapaLLM-Gemma-3-12B-v0.1.2-instruct',
  rada: 'hybrid',
} as const;

export type ModelId = typeof MODEL_IDS[keyof typeof MODEL_IDS];

export const DEFAULT_CHAT_MODEL_ID = MODEL_IDS.mamay;
export const OCR_MODEL_ID = MODEL_IDS.rukopys;

type StandardChatModel = {
  id: typeof MODEL_IDS.mamay | typeof MODEL_IDS.lapa;
  name: string;
  vision: boolean;
  mode: 'chat';
  badge?: never;
  description?: string;
};

type RukopysModel = {
  id: typeof MODEL_IDS.rukopys;
  name: string;
  vision: true;
  mode: 'ocr';
  badge: 'New';
  description: string;
};

type RadaModel = {
  id: typeof MODEL_IDS.rada;
  name: string;
  vision: true;
  mode: 'chat';
  badge: '⚖️';
  description: string;
};

type ModelDefinition = StandardChatModel | RukopysModel | RadaModel;

const models = [
  {id: MODEL_IDS.mamay, name: 'MamayLM Gemma 3 27B', vision: true, mode: 'chat'},
  {id: MODEL_IDS.rukopys, name: 'Rukopys OCR', vision: true, mode: 'ocr', badge: 'New', description: 'Розпізнавання українських рукописів із зображень.'},
  {id: MODEL_IDS.lapa, name: 'LapaLLM Gemma 3 12B', vision: true, mode: 'chat'},
  {
    id: MODEL_IDS.rada,
    name: 'Рада',
    vision: true,
    mode: 'chat',
    badge: '⚖️',
    description: 'Режим Рада поєднує LapaLLM для пошуку, інструментів і збору даних та MamayLM для глибшого аналізу й фінальної відповіді.',
  },
] as const satisfies readonly ModelDefinition[];

export const CONFIG = {
  backendUrl,
  ocrBackendUrl: getOcrBackendUrl(window.location.origin, backendUrl),
  enableVision: process.env.REACT_APP_ENABLE_VISION === 'true',
  models,
  acceptedFiles: '.pdf,.docx,.txt,.json,.md,.csv,.xml,.yaml,.yml,.html,.py,.js,.ts,.java,.c,.cpp',
  storageKeys: {
    sessions: 'lapathoniia-sessions',
    chatPrefix: 'lapathoniia-chat-',
  },
} as const;
